<script setup lang="ts">
import { HaveSubAlarm } from "#components"
import { useDialog } from "~/composables/local/dialog"
import type { LimitedSubscriptionModel } from "~/utils/generated/api"

defineProps<{
	data: LimitedSubscriptionModel[]
}>()

const { userData } = useLogin()
const notify = useNotification()
const haveSubAlarm = useDialog(HaveSubAlarm)

function subscriptionHandler(id?: string) {
	if (userData.value?.userSubscription?.active) {
		haveSubAlarm.open()
		return
	}

	if (userData.value?.id)
		navigateTo(`/app?subscriptionId=${id}`)
	else
		navigateTo(`/app/login?subscriptionId=${id}`)
}

function creditHandler(amount?: number) {
	if (!amount) {
		notify.errorText({ description: "مقدار صفر است." })
		return
	}

	if (userData.value?.id)
		navigateTo(`/app?amount=${amount}`)
	else
		navigateTo(`/app/login?amount=${amount}`)
}
</script>

<template>
	<div class="relative">
		<NuxtImg
			loading="lazy"
			src="/images/patterns/central-gradient.svg"
			class="absolute inset-x-0 z-0 m-x-auto"
			width="1440"
			height="500" />

		<NuxtImg
			loading="lazy"
			src="/images/patterns/top-vector.svg"
			class="absolute inset-x-0 top-0 z-0 m-x-auto"
			width="1440"
			height="409" />

		<NuxtImg
			loading="lazy"
			src="/images/patterns/bot-vector.svg"
			class="absolute inset-x-0 bottom-0 z-0 m-x-auto"
			width="1440"
			height="409" />

		<section class="z-1 bg-top py-12">
			<div class="relative z-1 w-full flex flex-col items-center justify-center container">
				<LandingTitle class="mb-12">
					<template #title>
						پلن های خرید
					</template>

					<template #description>
						با توجه به نیاز شما، اعتبار محور و اشتراک ماهانه را پشتیبانی می کنیم !
					</template>
				</LandingTitle>

				<UTabs
					default-value="subscription"
					class="w-full">
					<div class="mb-12 flex items-center justify-center">
						<UTabsList class="bg-background shadow-lg">
							<UTabsTrigger
								value="subscription"
								class="px-4 py-2 data-[state=active]:bg-website-primary data-[state=inactive]:bg-background data-[state=active]:text-white">
								خرید اشتراک
							</UTabsTrigger>

							<UTabsTrigger
								class="px-4 py-2 data-[state=active]:bg-website-primary data-[state=inactive]:bg-background data-[state=active]:text-white"
								value="credit">
								خرید اعتبار
							</UTabsTrigger>
						</UTabsList>
					</div>

					<UTabsContent
						value="subscription"
						class="m-0">
						<SubscriptionsTab
							class="w-full"
							:data="data"
							@go="subscriptionHandler" />
					</UTabsContent>

					<UTabsContent
						value="credit"
						class="m-0 flex items-center justify-center">
						<div class="flex justify-center">
							<CreditTab @click="creditHandler" />
						</div>
					</UTabsContent>
				</UTabs>

				<p class="mt-8 text-center text-[#4D4F5C]">
					پلن رایگان، به شکل روزانه و بامداد هر شب، دوباره شارژ میشه.
				</p>
			</div>
		</section>
	</div>
</template>
